Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.StageDisplayState = module.exports.default = {
	FULL_SCREEN: "fullScreen",
	FULL_SCREEN_INTERACTIVE: "fullScreenInteractive",
	NORMAL: "normal"
};